jQuery(function($){
	$('.store-item .voicing-selector .voicing').on('click', function(){
		const parentClass = '.store-item';
		switchVoicing($(this), parentClass);
		switchVoicingUrl($(this));
	});

	$('.single-cs-song-wrapper .voicing-selector .voicing').on('click', function(){
		const parentClass = '.single-cs-song-wrapper';
		switchVoicing($(this), parentClass);
	});

	function switchVoicing(el, parentClass) {
		const voicingClasses = JSON.parse(atob(el.closest('.voicing-selector').attr('voicing-classes')));
		console.log(voicingClasses);

		$.each(voicingClasses, function(i, item){
			el.closest(parentClass).removeClass(item).addClass(el.attr('parent-class'));
		});
		el.closest(parentClass).addClass(el.attr('parent-class'));		
	}

	function switchVoicingUrl(el) {
		const voicing = el.attr('voicing-label');

		const links = el.closest('.store-item').find('.song-title a, .details-link a');
		links.each(function(){
			const href = $(this).attr('href');
			$(this).attr('href', replaceUrlParam(href, 'voicing', voicing));
		});
	}

	function replaceUrlParam(url, paramName, paramValue) {
		if(paramValue == null) paramValue = '';

		var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
		if(url.search(pattern) >= 0) return url.replace(pattern, '$1' + paramValue + '$2');

		url = url.replace(/[?#]$/,'');
		return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
	}
});